<div class="my-4">
  <div class="mb-4 text-center font-semibold text-lg">{{ title }}</div>

  <!-- File Cabinet Home: choose destination folder (purpose is derived) -->
  <div class="mb-4 px-4" *ngIf="requiresDestination">
    <div class="mb-2 text-sm font-medium text-secondary">Where should this be saved?</div>
    <mat-form-field class="w-full" appearance="outline">
      <mat-label>Save to folder</mat-label>
      <mat-select
        [(ngModel)]="selectedDestinationCode"
        [disabled]="isUploading || loadingPurposes || destinations.length === 0"
        (selectionChange)="onDestinationChanged()">
        <mat-option *ngFor="let destination of destinations" [value]="destination.code">
          {{ destination.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="text-xs text-hint" *ngIf="loadingPurposes">Loading folders...</div>
    <div class="text-xs text-warn" *ngIf="!loadingPurposes && destinations.length === 0">
      No folders available.
    </div>
  </div>

  <!-- Legacy Step 1: Purpose selector (only when caller opts in and not using destination mode) -->
  <div class="mb-4 px-4" *ngIf="requiresFilePurpose">
    <div class="mb-2 text-sm font-medium text-secondary">Step 1: Select file purpose</div>
    <mat-form-field class="w-full" appearance="outline">
      <mat-label>File Purpose</mat-label>
      <mat-select
        [(ngModel)]="selectedFilePurposeId"
        [disabled]="isUploading || loadingPurposes || filePurposeGroups.length === 0"
        (selectionChange)="onPurposeChanged()">
        <mat-optgroup *ngFor="let group of filePurposeGroups" [label]="group.label">
          <mat-option *ngFor="let purpose of group.purposes" [value]="purpose.file_purpose_id">
            {{ purpose.file_purpose_label }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
    <div class="text-xs text-hint" *ngIf="loadingPurposes">Loading purposes...</div>
    <div class="text-xs text-warn" *ngIf="!loadingPurposes && filePurposes.length === 0">
      No file purposes available.
    </div>
  </div>

  <!-- File selection -->
  <div class="mb-2 px-4 text-sm font-medium text-secondary" *ngIf="requiresDestination || requiresFilePurpose">
    {{ requiresDestination || requiresFilePurpose ? 'Select file(s)' : '' }}
  </div>

  <div class="px-2">
    <cipx-file-upload
      (fileUploadChanged)="onFileUploadChanged($event)"
      [currentConfig]="uploadConfig"
      [isUploading]="isUploading"
      [multiple]="true"
      class="w-full"></cipx-file-upload>
  </div>

  <!-- Manual upload button: destination mode or legacy purpose mode -->
  <div
    class="mt-4 px-4 flex justify-center"
    *ngIf="(requiresDestination || requiresFilePurpose) && queuedFiles.length > 0 && !isUploading">
    <button
      mat-flat-button
      color="primary"
      class="w-full"
      (click)="startUpload()"
      [disabled]="!canUpload">
      Upload {{ queuedFiles.length }} File(s)
    </button>
  </div>

  <div
    class="mt-2 px-4 text-center text-xs text-secondary"
    *ngIf="requiresDestination && queuedFiles.length > 0 && !selectedDestinationCode && !isUploading">
    Choose a folder to enable upload.
  </div>

  <div
    class="mt-2 px-4 text-center text-xs text-secondary"
    *ngIf="requiresFilePurpose && queuedFiles.length > 0 && !selectedFilePurposeId && !isUploading">
    Select a file purpose to enable upload.
  </div>
</div>
